<template>
  <div class="dt-time">
    <div class="dt-time__select">
      <select v-model="hour">
        <option v-for="h in hours" :key="h" :value="h">{{
          h | formatNumber
        }}</option>
      </select>
    </div>
    :
    <div class="dt-time__select">
      <select v-model="minute">
        <option v-for="m in minutes" :key="m" :value="m">{{
          m | formatNumber
        }}</option>
      </select>
    </div>
    :
    <div class="dt-time__select">
      <template v-if="secondPicker">
        <select v-model="second">
          <option v-for="s in 60" :key="s - 1" :value="s - 1">{{
            (s - 1) | formatNumber
          }}</option>
        </select>
      </template>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";
export default {
  filters: {
    formatNumber: value => {
      if (value < 10) {
        return "0" + value.toString();
      }
      return value.toString();
    }
  },
  props: {
    miniuteIncrement: {
      type: Number,
      default: 5
    },
    hour24: {
      type: Boolean,
      default: true
    },
    secondPicker: {
      type: Boolean,
      default: false
    },
    currentTime: {
      type: DateTime,
      default: () => DateTime.local().startOf("day")
    }
  },
  data() {
    const newTime = DateTime.local().startOf("day");
    const { hour, minute, second } = this.currentTime
      ? this.currentTime
      : newTime;
    return {
      hour: this.hour24 ? hour : hour % 12 || 12,
      minute: minute - (minute % this.miniuteIncrement),
      second: second,
      ampm: hour < 12 ? "AM" : "PM"
    };
  },
  computed: {
    hours() {
      let values = [];
      let max = this.hour24 ? 24 : 12;
      for (let i = 0; i < max; i++) {
        values.push(this.hour24 ? i : i + 1);
      }
      return values;
    },
    minutes() {
      let values = [];
      let max = 60;
      for (let i = 0; i < max; i = i + this.miniuteIncrement) {
        values.push(i);
      }
      return values;
    }
  },
  watch: {
    currentTime(v) {
      this.parseTime(v);
    },
    hour() {
      this.onChange();
    },
    minute() {
      this.onChange();
    },
    second() {
      this.onChange();
    },
    ampm() {
      this.onChange();
    }
  },
  methods: {
    getHour() {
      if (this.hour24) {
        return this.hour;
      } else {
        if (this.hour === 12) {
          return this.ampm === "AM" ? 0 : 12;
        } else {
          return this.hour + (this.ampm === "PM" ? 12 : 0);
        }
      }
    },
    onChange() {
      this.$emit("update", {
        hour: this.getHour(),
        minute: this.minute,
        second: this.second
      });
    },
    parseTime(date) {
      const { hour, minute, second } = date;
      this.hour = this.hour24 ? hour : hour % 12 || 12;
      this.minute = minute - (minute % this.miniuteIncrement);
      this.second = second;
      this.ampm = hour < 12 ? "AM" : "PM";
    }
  }
};
</script>

<style lang="scss" scoped></style>
